import React, { Component } from "react";

import Coming_Soon_Picture from "../../Images/coming_soon.png";

import {
  Card,
  Button,
  CardImg,
  CardTitle,
  CardText,
  CardDeck,
  CardBody,
} from "reactstrap";

import "./item.css";

class Item extends Component {
  render() {
    return (
      <CardDeck>
        <div className="Shop-list-item">
          <Card style={{ width: "20rem", height: "25rem" }}>
            <CardImg
              top
              width="100%"
              src={this.props.item.url || Coming_Soon_Picture}
              alt="Card image cap"
            />
            <CardBody
              style={{
                padding: ".5rem",
                backgroundColor: "#72a1e5",
                color: "#f0dcca",
              }}
            >
              <CardTitle
                style={{
                  margin: 0,
                  fontSize: "2rem",
                  overflowY: "hidden",
                  height: "3rem",
                }}
              >
                {this.props.item.title}
              </CardTitle>
              <CardText
                style={{
                  width: "20rem",
                  height: "6em",
                  textAlign: "left",
                  marginBottom: "1rem",
                  overflowY: "hidden",
                }}
              >
                {this.props.item.body}
              </CardText>
              <Button
                style={{
                  borderColor: "#2f6690",
                  backgroundColor: "#2f6690",
                }}
                size="md"
                onClick={() => this.props.addToCart(this.props.item.id)}
              >
                Add To Cart: ${this.props.item.cost}
              </Button>
            </CardBody>
          </Card>
        </div>
      </CardDeck>
    );
  }
}
export default Item;
